import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { MdSnackBar } from '@angular/material'
import { Angulartics2 } from 'angulartics2'

import { AuthService } from '../auth/auth.service'
import { UserService } from '../users/shared/user.service'
import { TaskService } from '../core/tasks/task.service'
import { DialogService } from '../dialog/shared/dialog.service'
import { CreditService } from '../consumables/consumables.module'

import { User } from '../users/shared/user.model'
import { Task } from '../core/tasks/task.model'

import { Subscription } from 'rxjs/Subscription'

@Component({
  selector: 'cm-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileComponent implements OnInit, OnDestroy {

  user: User

  private subscription: Subscription

  private descriptionTimeout: any
  private descriptionPromise: Promise<any>

  constructor(private authService: AuthService,
    private userService: UserService,
    private creditService: CreditService,
    private taskService: TaskService,
    private dialogService: DialogService,
    private snackBar: MdSnackBar,
    private router: Router,
    private angulartics2: Angulartics2) { }

  ngOnInit() {
    const uid = this.authService.currentUser.uid
    this.subscription = this.userService.getUser(uid)
      .subscribe(user => this.user = user)
  }

  ngOnDestroy() {
    if (this.descriptionPromise) {
      this.descriptionPromise.then(() => {
        clearTimeout(this.descriptionTimeout)
      })

      this.descriptionPromise = null
    }

    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  updateDescription(value: string) {
    clearTimeout(this.descriptionTimeout)
    this.descriptionPromise = new Promise((resolve, reject) => {
      this.descriptionTimeout = setTimeout(() => {
        this.userService.updateDescription(this.user.uid, value)
          .then(() => resolve())
          .catch(() => reject())

        this.checkProfileComplete()
      }, 1600)
    })
  }

  updateProfilePicture(data: any, index: number) {
    this.userService.updateProfilePicture(this.user.uid, data, index)
    this.checkProfileComplete()
  }

  removeProfilePicture(index: number) {
    this.userService.removeProfilePicture(this.user.uid, index)
  }

  share() {
    this.dialogService.share()
      .subscribe()
  }

  logout() {
    this.ngOnDestroy()

    this.router.navigate(['/login'])
      .then(() => {
        this.authService.signOut()
      })
  }

  deleteAccount() {
    this.dialogService
      .confirm('Suppression du compte', 'Êtes vous sûr de vouloir supprimer votre compte. Cet action est irréversible.')
      .subscribe((result: boolean) => {
        if (result) {
          const task = Task.createDeleteAccountTask(this.user.uid)
          this.taskService.startTask(task)
          window.localStorage.clear()

          this.logout()
        }
      })
  }

  private checkProfileComplete() {
    if (this.user.description.length >= 10 && this.user.images.length === 3) {
      this.onProfileCompleted()
    }
  }

  private onProfileCompleted() {
    this.angulartics2.eventTrack.next({ action: 'complete', properties: {category: 'profile'}})

    this.creditService.addCreditsFromBonus(this.user.uid, 'finished_profile')
      .then((result: boolean) => {
        if (result === true) {
          this.snackBar.open('Profile complété - 10 crédits', null, {
            duration: 3000
          })
        }
      })
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/profile.component.ts